import { render } from "./ReportGroupItem.vue?vue&type=template&id=4500d1d0"
import script from "./ReportGroupItem.vue?vue&type=script&lang=js"
export * from "./ReportGroupItem.vue?vue&type=script&lang=js"

import "./ReportGroupItem.vue?vue&type=style&index=0&id=4500d1d0&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.28.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__